var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto pa-5 d-flex flex-column-reverse",staticStyle:{"height":"100%"},attrs:{"id":"iframeContainer"}},[_c('v-btn',{staticClass:"mx-auto mt-5",staticStyle:{"width":"120px"},attrs:{"color":"error"},on:{"click":function($event){return _vm.$emit('closeDialog');}}},[_vm._v(" Close ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }